import React, { useState } from "react";
import { NavBarMain } from "..";
import diamond from "../../static/diamond.png";
import customers from "../../static/customers.png";

import {
  BotReferralContainer,
  MainHeader,
  SecondaryContainer,
  TopSection,
  ContentSection,
  StatsSection,
  StatBox,
  StatIcon,
  StatContent,
  StatLabel,
  StatValue,
  ReferralLink,
  LinkInput,
  ShareButton,
  RewardText,
  ReferralImage,
  Title,
  ExplainerSection,
  ExplainerTitle,
  ExplainerText,
  ExplainerCTA,
  FAQSection,
  FAQTitle,
  FAQItem,
  FAQQuestion,
  FAQAnswer
} from "./BotReferral.styled";
import { useTranslation } from "react-i18next";

export const BotReferral = ({ history }) => {
  const { t } = useTranslation();
  const [referralLink] = useState("Rugbull.gg/ref=183281231");
  const [openFaqItems, setOpenFaqItems] = useState({});

  const handleCopyLink = () => {
    navigator.clipboard.writeText(referralLink);
  };

  const toggleFaqItem = (index) => {
    setOpenFaqItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      <BotReferralContainer>
        <NavBarMain currentPage="bot" type="referral" history={history} />
        <MainHeader>
          <Title>{t('referrals')}</Title>
          <TopSection>
            <ContentSection>
              <StatsSection>
                <StatBox>
                  <StatIcon>
                    <img src={customers} alt="Customers" />
                  </StatIcon>
                  <StatContent>
                    <StatLabel>{t('totalReferrals')}</StatLabel>
                    <StatValue>0</StatValue>
                  </StatContent>
                </StatBox>
                <StatBox>
                  <StatIcon>
                    <img src={diamond} alt="Diamond" />
                  </StatIcon>
                  <StatContent>
                    <StatLabel>{t('totalEarned')}</StatLabel>
                    <StatValue>0.00€</StatValue>
                  </StatContent>
                </StatBox>
              </StatsSection>

              {/* <ReferralLink>
                <LinkInput 
                  value={referralLink}
                  readOnly
                />
                <ShareButton onClick={handleCopyLink}>
                  {t('share')}
                </ShareButton>
              </ReferralLink> */}

              {/* <RewardText>
                {t('get')} <span>100.0</span> {t('forEachInvitedUser')}
              </RewardText> */}
            </ContentSection>
          </TopSection>
        </MainHeader>

        <SecondaryContainer>
            <ExplainerTitle>{t('referralExplainerTitle')}</ExplainerTitle>
          <ExplainerSection>
            <ExplainerText dangerouslySetInnerHTML={{ __html: t('referralExplainerText') }} />
          </ExplainerSection>

            <FAQTitle>{t('faqTitle')}</FAQTitle>
          <FAQSection>
            <FAQItem onClick={() => toggleFaqItem(0)}>
              <FAQQuestion isOpen={openFaqItems[0]}>{t('faqQuestion1')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[0]}>{t('faqAnswer1')}</FAQAnswer>
            </FAQItem>
            <FAQItem onClick={() => toggleFaqItem(1)}>
              <FAQQuestion isOpen={openFaqItems[1]}>{t('faqQuestion2')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[1]}>{t('faqAnswer2')}</FAQAnswer>
            </FAQItem>
            <FAQItem onClick={() => toggleFaqItem(2)}>
              <FAQQuestion isOpen={openFaqItems[2]}>{t('faqQuestion3')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[2]}>{t('faqAnswer3')}</FAQAnswer>
            </FAQItem>
            <FAQItem onClick={() => toggleFaqItem(3)}>
              <FAQQuestion isOpen={openFaqItems[3]}>{t('faqQuestion4')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[3]}>{t('faqAnswer4')}</FAQAnswer>
            </FAQItem>
            <FAQItem onClick={() => toggleFaqItem(5)}>
              <FAQQuestion isOpen={openFaqItems[5]}>{t('faqQuestion6')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[5]}>{t('faqAnswer6')}</FAQAnswer>
            </FAQItem>
            <FAQItem onClick={() => toggleFaqItem(6)}>
              <FAQQuestion isOpen={openFaqItems[6]}>{t('faqQuestion7')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[6]}>{t('faqAnswer7')}</FAQAnswer>
            </FAQItem>
            <FAQItem onClick={() => toggleFaqItem(7)}>
              <FAQQuestion isOpen={openFaqItems[7]}>{t('faqQuestion8')}</FAQQuestion>
              <FAQAnswer isOpen={openFaqItems[7]}>{t('faqAnswer8')}</FAQAnswer>
            </FAQItem>
          </FAQSection>
        </SecondaryContainer>
      </BotReferralContainer>
    </>
  );
};
